import { render, staticRenderFns } from "./MallShopOrder.vue?vue&type=template&id=f03df9da&scoped=true"
import script from "./MallShopOrder.vue?vue&type=script&lang=js"
export * from "./MallShopOrder.vue?vue&type=script&lang=js"
import style0 from "./MallShopOrder.vue?vue&type=style&index=0&id=f03df9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03df9da",
  null
  
)

export default component.exports